import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "form-box hardware-edit" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = { class: "field" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Name", -1)
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { class: "field field-select" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "store" }, "Store", -1)
const _hoisted_9 = ["textContent"]
const _hoisted_10 = { class: "field" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "date" }, "Date", -1)
const _hoisted_12 = ["textContent"]
const _hoisted_13 = { class: "field" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "total_price" }, "Total Price", -1)
const _hoisted_15 = ["textContent"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h3", null, "Items", -1)
const _hoisted_17 = { class: "fields" }
const _hoisted_18 = { class: "field field-auto-complete" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "componentId" }, "Component", -1)
const _hoisted_20 = { class: "field" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Description", -1)
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = { class: "field" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { for: "price" }, "Price", -1)
const _hoisted_25 = ["onUpdate:modelValue"]
const _hoisted_26 = { class: "field" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { for: "count" }, "Count", -1)
const _hoisted_28 = ["onUpdate:modelValue"]
const _hoisted_29 = { class: "buttons" }
const _hoisted_30 = ["textContent"]

import { computed, onMounted, reactive, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import {
  HardwarePurchase,
  defaultPurchase,
  TypeLabel,
  HardwareComponent,
} from '@/models/hardware.model';
import Choice, { Item } from '@/components/choice/Choice.vue';
import { Actions, Mutations } from '@/store';
import { Store } from '@/models/store.model';
import AutoComplete from '../auto-complete/AutoComplete.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HardwarePurchaseEdit',
  setup(__props) {

const store = useStore();
const router = useRouter();
const route = useRoute();

const stores = computed<Item[]>(() =>
  store.state.stores.map((s: Store) => ({ label: s.name, value: s.id })),
);

const purchase = reactive<HardwarePurchase>(
  new HardwarePurchase(defaultPurchase),
);

const componentOptions = computed<TypeLabel[]>(
  () =>
    [{ label: '-', value: '-1' }].concat(
      ...store.state.hardwareComponents?.map((c: HardwareComponent) => ({
        label: `${c.brand} ${c.name}`,
        value: c.id,
      })),
    ) || [],
);

const isEdit = ref<boolean>(false);

const action = computed<string>(() => {
  return isEdit.value ? 'Edit' : 'Add';
});
const title = computed<string>(() => {
  return action.value + ' hardware purchase';
});

onMounted(async () => {
  store.dispatch(Actions.GetStores);
  store.dispatch(Actions.GetHardwareConfiguration);
  store.dispatch(Actions.GetHardwareComponents);
  if (~route.path.indexOf('edit') && !store.state.item) {
    // on reload
    isEdit.value = true;
    store
      .dispatch(Actions.GetHardwarePurchaseByName, route.params.title)
      .then((h) => {
        Object.assign(purchase, h);
      });
  } else if (store.state.item) {
    // on edit from another page
    isEdit.value = true;
    Object.assign(purchase, store.state.item);
  } else {
    // get all purchases first, so that adding a purchase works correctly
    store.dispatch(Actions.GetHardwarePurchases);
    Object.assign(purchase, new HardwarePurchase(defaultPurchase));
  }
});

const cancel = () => {
  store.commit(Mutations.SetViewItem, null);
  router.push('/hardware');
};

const submit = async () => {
  if (purchase.isValid()) {
    const response = await store.dispatch(Actions.UpdateHardwarePurchase, {
      item: purchase,
      edit: isEdit.value,
    });
    if (response.status) {
      cancel();
    }
  }
};

const addItem = () => {
  Object.assign(purchase, {
    ...purchase,
    items: [
      ...(purchase.items || []),
      { componentId: -1, description: '', price: 0 },
    ],
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h3", {
      textContent: _toDisplayString(_unref(title))
    }, null, 8, _hoisted_2),
    purchase
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _withModifiers(submit, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "name",
              name: "name",
              autofocus: "",
              autocomplete: "off",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((purchase.name) = $event))
            }, null, 512), [
              [_vModelText, purchase.name]
            ]),
            (!purchase.isValid('name'))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-validation",
                  textContent: _toDisplayString(purchase.validation.messages.name)
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(Choice, {
              id: "store",
              modelValue: purchase.store,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((purchase.store) = $event)),
              items: _unref(stores)
            }, null, 8, ["modelValue", "items"]),
            (!purchase.isValid('store'))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-validation",
                  textContent: _toDisplayString(purchase.validation.messages.store)
                }, null, 8, _hoisted_9))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _withDirectives(_createElementVNode("input", {
              type: "date",
              class: "date",
              id: "date",
              name: "date",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((purchase.date) = $event))
            }, null, 512), [
              [_vModelText, purchase.date]
            ]),
            (!purchase.isValid('date'))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-validation",
                  textContent: _toDisplayString(purchase.validation.messages.date)
                }, null, 8, _hoisted_12))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("input", {
              type: "number",
              class: "price",
              id: "total_price",
              name: "total_price",
              placeholder: "0.00",
              lang: "en-US",
              step: "0.01",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((purchase.total_price) = $event))
            }, null, 512), [
              [_vModelText, purchase.total_price]
            ]),
            (!purchase.isValid('price'))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-validation",
                  textContent: _toDisplayString(purchase.validation.messages.price)
                }, null, 8, _hoisted_15))
              : _createCommentVNode("", true)
          ]),
          _hoisted_16,
          _createElementVNode("ul", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(purchase.items, (prop, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: "property"
              }, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode(AutoComplete, {
                    id: "componentId",
                    modelValue: prop.componentId,
                    "onUpdate:modelValue": ($event: any) => ((prop.componentId) = $event),
                    items: _unref(componentOptions)
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "description",
                    name: "description",
                    autofocus: "",
                    autocomplete: "off",
                    "onUpdate:modelValue": ($event: any) => ((prop.description) = $event)
                  }, null, 8, _hoisted_22), [
                    [_vModelText, prop.description]
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    id: "price",
                    name: "price",
                    placeholder: "0.00",
                    lang: "en-US",
                    step: "0.01",
                    autocomplete: "off",
                    "onUpdate:modelValue": ($event: any) => ((prop.price) = $event)
                  }, null, 8, _hoisted_25), [
                    [_vModelText, prop.price]
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    id: "count",
                    name: "count",
                    placeholder: "1",
                    autocomplete: "off",
                    "onUpdate:modelValue": ($event: any) => ((prop.count) = $event)
                  }, null, 8, _hoisted_28), [
                    [_vModelText, prop.count]
                  ])
                ])
              ]))
            }), 128)),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                type: "button",
                onClick: addItem
              }, "Add Item")
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("button", {
              type: "button",
              class: "cancel",
              onClick: cancel
            }, "Cancel"),
            _createElementVNode("button", {
              type: "submit",
              textContent: _toDisplayString(_unref(action))
            }, null, 8, _hoisted_30)
          ])
        ], 40, _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}
}

})